const MaterialTermsQuery = (id) => {
    return `
    query {
      deleteMaterialTerms(id: "${id}")
    } 
    `
}

export default MaterialTermsQuery